import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {HotelTileLayout} from '@/components/HotelTileLayout';

type Props = {
  small?: boolean;
};

export const Container = styled(HotelTileLayout)<Props>(
  ({theme, small}) => css`
    cursor: pointer;
    user-select: none;
    max-width: ${small && '343px'};

    img {
      background-color: ${theme.colors.backgroundStateDisabled};

      /**
           * Hide alt text in Firefox
           * @see https://stackoverflow.com/a/51399798
           */
      &:-moz-loading {
        color: ${theme.colors.backgroundStateDisabled};
      }
    }
  `
);
